<template>
  <div class="document-file-upload">
    <!-- Upload Area -->
    <div class="uploadOuter">
      <label class="btn btn-info" :for="uploadId" @click="onUploadClick">
        <i class="uil-upload"></i>
        {{ $t("general.upload") }}
      </label>
      <strong>{{ $t("general.or") }}</strong>
      <span class="dragBox" :class="{ 'draging': isDragging }">
        <i :class="icon"></i>
        {{ $t(contentTypeKey + "_drag_drop") }}
        <input 
          :id="uploadId" 
          :accept="acceptableFileType" 
          draggable="true" 
          type="file"
          @click="onUploadClick"
          @change="handleFileChange" 
          @dragenter="isDragging = true" 
          @dragleave="isDragging = false" 
          @dragover.prevent 
        />
      </span>
    </div>

    <!-- Edit modunda mevcut dosya preview -->
    <div v-if="isEditMode && existingFile" class="mt-4">
      <p>
        <div class="file-info">
          <div>{{ $t('general.format') }} : <span>{{ existingFile.name.split(".").pop().toUpperCase() }}</span></div>
          <div>{{ $t('general.document_name') }}: <span> {{ existingFile.name.toUpperCase() }} </span></div>
          <div>{{ $t('general.download_link') }}: <a :href="existingFile.file_link" target="_blank">{{ $t('general.download') }}</a></div>
        </div>
      </p>
      
      <!-- Görsel doküman için image preview -->
      <img 
        v-if="fileCategoryId === 2" 
        :src="existingFile.file_link" 
        class="img-fluid mt-3" 
        style="max-height: 300px; object-fit: cover;"
      >
      
      <!-- Ses dokümanı için audio player -->
      <audio 
        v-if="fileCategoryId === 6" 
        :src="existingFile.file_link" 
        controls 
        class="w-100 mt-3"
      ></audio>
      
      <!-- PDF için embed (opsiyonel) -->
      <embed 
        v-if="fileCategoryId === 3"
        :src="existingFile.file_link"
        type="application/pdf"
        width="100%"
        height="600px"
        class="mt-3"
      />
    </div>

    <!-- Yeni dosya preview alanı -->
    <div id="preview"></div>
  </div>
</template>

<script>
import bridge from "@/core/services/bridge.service";
import native from "@/mobile/mobile.fileHandler";

export default {
  name: "DocumentFileUpload",
  props: {
    icon: {
      type: String,
      default: "icon-feather-file"
    },
    contentTypeKey: {
      type: String,
      required: true
    },
    acceptableFileType: {
      type: String,
      default: "*"
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    existingFile: {
      type: Object,
      default: null
    },
    fileCategoryId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isDragging: false,
      uploadId: `uploadFile_${Math.random().toString(36).substr(2, 9)}`,
      _waitingForFile: false,
    };
  },
  mounted() {
    if (!bridge.isNative) {
      return;
    }
    this._unsubscribePickFile = bridge.on("PICK_FILE_RESULT", (payload) => {
      if (!this._waitingForFile) return;
      this._waitingForFile = false;
      if (!payload.success || !payload.file) return;
      const { name, type, base64 } = payload.file;
      const byteString = atob(base64);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      this.$emit("file-uploaded", new File([ab], name, { type }));
      this.isDragging = false;
    });
  },
  beforeDestroy() {
    if (this._unsubscribePickFile) {
      this._unsubscribePickFile();
    }
  },
  methods: {
    onUploadClick(event) {
      if (!bridge.isNative) {
        return;
      }
      event.preventDefault();
      this._waitingForFile = true;
      native.pickFile(this.acceptableFileType);
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.$emit('file-uploaded', file);
        this.isDragging = false;
      }
    }
  }
};
</script>

<style scoped>
.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
}

.dragBox {
  width: auto;
  padding: 0 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  transition: transform 0.3s;
}

.dragBox.draging {
  transform: scale(1.05);
  border-color: #666;
}

.uploadOuter strong {
  padding: 0 10px;
}

.uploadOuter {
  text-align: center;
  padding: 20px;
}

.file-info {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.file-info div {
  margin-bottom: 0;
}

.file-info span {
  font-weight: 600;
  color: #333;
}

.file-info a {
  color: #007bff;
  text-decoration: none;
}

.file-info a:hover {
  text-decoration: underline;
}
</style>

